/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-06-07 15:31:30
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\k.js
 */
import request from '@/utils/request'

/*翻料处理-余料翻料信息列表*/
export function query_page(data) {
  return request({
    url: '/icps/system/sign/intelligent/residueTurnOut/query_page',
    method: 'post',
    data
  })
}

/*翻料处理-获取余料车辆*/
export function getResidualTreatment(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/getResidualTreatment',
    method: 'post',
    data
  })
}

//翻料处理-获取车辆排队信息*/
export function get_queue_up_inform(data) {
    return request({
      url: "/icps/system/sign/intelligent/proDispatchLogistics/get_queue_up_inform",
      method: "post",
      data,
    });
}
  //翻料处理-保存*/
export function turnoverTreatment(data) {
    return request({
      url: "/icps/system/sign/intelligent/proDispatchLogistics/turnoverTreatment",
      method: "post",
      data,
    });
  }

  //异常处理/
export function logisticsAbnormal(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/logisticsAbnormal",
    method: "post",
    data,
  });
}

 //查看异常/
 export function queryAbnormal(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/queryAbnormal",
    method: "get",
    params,
  });
}